import React from 'react';
import Button from './Button';
import { theme } from '../theme/theme';

const FilterButtons = ({
  viewType,
  onViewTypeChange,
  onSetDateClick,
  showDateInputs,
  isLoading,
  onApplyFilter,
  onCancel,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  getCurrentDate,
  additionalButtons = []
}) => {
  const defaultButtonStyle = {
    color: '#000000',
    background: '#D9D9D9',
    '&:hover': {
      background: '#D9D9D9',
      opacity: 0.9
    }
  };

  const activeButtonStyle = {
    color: '#000000',
    background: '#C6EAAC',
    '&:hover': {
      background: '#C6EAAC',
      opacity: 0.9
    }
  };

  const applyButtonStyle = {
    color: '#000000',
    background: '#82C853',
    '&:hover': {
      background: '#82C853',
      opacity: 0.9
    }
  };

  return (
    <div style={{ marginBottom: theme.spacing.lg }}>
      {!showDateInputs ? (
        <div style={{ display: 'flex', gap: theme.spacing.md, alignItems: 'center' }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => onViewTypeChange('week')}
            style={viewType === 'week' ? activeButtonStyle : defaultButtonStyle}
          >
            Last Week
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => onViewTypeChange('month')}
            style={viewType === 'month' ? activeButtonStyle : defaultButtonStyle}
          >
            Last Month
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={onSetDateClick}
            style={showDateInputs ? activeButtonStyle : defaultButtonStyle}
          >
            Set Date
          </Button>
          {additionalButtons.map((button, index) => (
            <Button
              key={index}
              variant="contained"
              color="primary"
              onClick={button.onClick}
              style={button.isActive ? activeButtonStyle : defaultButtonStyle}
            >
              {button.label}
            </Button>
          ))}
        </div>
      ) : (
        <div style={{ display: 'flex', gap: theme.spacing.md, alignItems: 'center' }}>
          <div>
            <label htmlFor="startDate" style={{ marginRight: theme.spacing.sm, ...theme.typography.body2 }}>Start Date:</label>
            <input 
              type="date" 
              id="startDate" 
              value={startDate} 
              onChange={onStartDateChange} 
              style={{ 
                padding: theme.spacing.sm, 
                borderRadius: theme.borderRadius.sm, 
                border: `1px solid ${theme.colors.grey[300]}`,
                fontFamily: theme.typography.fontFamily
              }}
              max={getCurrentDate()}
              disabled={isLoading}
            />
          </div>
          <div>
            <label htmlFor="endDate" style={{ marginRight: theme.spacing.sm, ...theme.typography.body2 }}>End Date:</label>
            <input 
              type="date" 
              id="endDate" 
              value={endDate} 
              onChange={onEndDateChange} 
              style={{ 
                padding: theme.spacing.sm, 
                borderRadius: theme.borderRadius.sm, 
                border: `1px solid ${theme.colors.grey[300]}`,
                fontFamily: theme.typography.fontFamily
              }}
              max={getCurrentDate()}
              disabled={isLoading}
            />
          </div>
          <Button
            onClick={onApplyFilter}
            variant="contained"
            color="primary"
            disabled={isLoading}
            style={applyButtonStyle}
          >
            {isLoading ? 'Loading...' : 'Apply'}
          </Button>
          <Button
            onClick={onCancel}
            variant="contained"
            color="primary"
            disabled={isLoading}
            style={defaultButtonStyle}
          >
            Cancel
          </Button>
        </div>
      )}
    </div>
  );
};

export default FilterButtons; 